import { c as _c } from "react/compiler-runtime";
import { IconMinusOutline18, IconPlusOutline18 } from "nucleo-ui-outline-18";
import { Input } from "@/components/ui/input";
import { useEffect, useState } from "react";
import { FieldDescription } from "./FieldDescription";
interface NumberInputProps {
  label: string;
  description?: string;
  headerRight?: React.ReactNode;
  value: number | string | undefined;
  onChange: (value: number | string | undefined) => void;
  min?: number;
  max?: number;
  step?: number;
  placeholder?: string;
}
export default function NumberInput(t0) {
  const $ = _c(51);
  const {
    label,
    description,
    headerRight,
    value,
    onChange,
    min,
    max,
    step: t1,
    placeholder
  } = t0;
  const step = t1 === undefined ? 1 : t1;
  let t2;
  if ($[0] !== value) {
    t2 = value?.toString() ?? "";
    $[0] = value;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const [inputValue, setInputValue] = useState(t2);
  let t3;
  let t4;
  if ($[2] !== value) {
    t3 = () => {
      setInputValue(value?.toString() ?? "");
    };
    t4 = [value];
    $[2] = value;
    $[3] = t3;
    $[4] = t4;
  } else {
    t3 = $[3];
    t4 = $[4];
  }
  useEffect(t3, t4);
  let t5;
  if ($[5] !== value) {
    t5 = typeof value === "string" && (value.includes("{{") || value.includes("}}"));
    $[5] = value;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  const isTemplate = t5;
  const getNumericValue = _temp;
  let t6;
  if ($[7] !== value) {
    t6 = getNumericValue(value);
    $[7] = value;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  const currentNumericValue = t6;
  let t7;
  if ($[9] !== onChange) {
    t7 = newInputValue => {
      if (newInputValue === "") {
        setInputValue("");
        onChange(undefined);
        return;
      }
      const maybeTemplate = newInputValue.includes("{") || newInputValue.includes("}");
      if (maybeTemplate) {
        const templatePattern = /^[\d{}.a-zA-Z_\-\s]*$/;
        if (templatePattern.test(newInputValue)) {
          setInputValue(newInputValue);
          onChange(newInputValue);
        }
        return;
      }
      const numberPattern = /^-?\d*\.?\d*$/;
      if (!numberPattern.test(newInputValue)) {
        return;
      }
      setInputValue(newInputValue);
      const numValue = parseFloat(newInputValue);
      if (!isNaN(numValue)) {
        onChange(numValue);
      }
    };
    $[9] = onChange;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const handleInputChange = t7;
  let t8;
  if ($[11] !== currentNumericValue || $[12] !== isTemplate || $[13] !== max || $[14] !== onChange || $[15] !== step) {
    t8 = () => {
      if (isTemplate) {
        return;
      }
      if (currentNumericValue === undefined) {
        return;
      }
      const newValue = currentNumericValue + step;
      if (max !== undefined && newValue > max) {
        return;
      }
      onChange(newValue);
    };
    $[11] = currentNumericValue;
    $[12] = isTemplate;
    $[13] = max;
    $[14] = onChange;
    $[15] = step;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  const handleIncrement = t8;
  let t9;
  if ($[17] !== currentNumericValue || $[18] !== isTemplate || $[19] !== min || $[20] !== onChange || $[21] !== step) {
    t9 = () => {
      if (isTemplate) {
        return;
      }
      if (currentNumericValue === undefined) {
        return;
      }
      const newValue_0 = currentNumericValue - step;
      if (min !== undefined && newValue_0 < min) {
        return;
      }
      onChange(newValue_0);
    };
    $[17] = currentNumericValue;
    $[18] = isTemplate;
    $[19] = min;
    $[20] = onChange;
    $[21] = step;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  const handleDecrement = t9;
  const canDecrement = !isTemplate && currentNumericValue !== undefined && (min === undefined || currentNumericValue > min);
  const canIncrement = !isTemplate && currentNumericValue !== undefined && (max === undefined || currentNumericValue < max);
  let t10;
  if ($[23] !== headerRight || $[24] !== label) {
    t10 = label && <div className="flex items-center justify-between gap-3"><label className="field-label block">{label}</label>{headerRight}</div>;
    $[23] = headerRight;
    $[24] = label;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== description) {
    t11 = description && <FieldDescription text={description} />;
    $[26] = description;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  const t12 = !canDecrement;
  let t13;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <IconMinusOutline18 className="h-3 w-3" />;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== handleDecrement || $[30] !== t12) {
    t14 = <button type="button" onClick={handleDecrement} disabled={t12} className="border-ds-neutral-300 text-ds-text-subtle dark:border-ds-neutral-700 dark:text-ds-text-disabled dark:hover:bg-ds-neutral-700 bg-ds-surface-card hover:bg-ds-surface-hover flex h-9 w-9 items-center justify-center rounded-lg border transition-colors disabled:cursor-not-allowed disabled:opacity-40" aria-label="Decrease value">{t13}</button>;
    $[29] = handleDecrement;
    $[30] = t12;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  const t15 = isTemplate ? "text" : "decimal";
  let t16;
  if ($[32] !== handleInputChange) {
    t16 = e => handleInputChange(e.target.value);
    $[32] = handleInputChange;
    $[33] = t16;
  } else {
    t16 = $[33];
  }
  const t17 = placeholder || "Enter number or {{template}}";
  let t18;
  if ($[34] !== inputValue || $[35] !== t15 || $[36] !== t16 || $[37] !== t17) {
    t18 = <Input type="text" inputMode={t15} value={inputValue} onChange={t16} placeholder={t17} className="text-ds-text-primary h-9 min-w-0 flex-1 text-center" />;
    $[34] = inputValue;
    $[35] = t15;
    $[36] = t16;
    $[37] = t17;
    $[38] = t18;
  } else {
    t18 = $[38];
  }
  const t19 = !canIncrement;
  let t20;
  if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <IconPlusOutline18 className="h-3 w-3" />;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== handleIncrement || $[41] !== t19) {
    t21 = <button type="button" onClick={handleIncrement} disabled={t19} className="border-ds-neutral-300 text-ds-text-subtle dark:border-ds-neutral-700 dark:text-ds-text-disabled dark:hover:bg-ds-neutral-700 bg-ds-surface-card hover:bg-ds-surface-hover flex h-9 w-9 items-center justify-center rounded-lg border transition-colors disabled:cursor-not-allowed disabled:opacity-40" aria-label="Increase value">{t20}</button>;
    $[40] = handleIncrement;
    $[41] = t19;
    $[42] = t21;
  } else {
    t21 = $[42];
  }
  let t22;
  if ($[43] !== t14 || $[44] !== t18 || $[45] !== t21) {
    t22 = <div className="flex items-center gap-1">{t14}{t18}{t21}</div>;
    $[43] = t14;
    $[44] = t18;
    $[45] = t21;
    $[46] = t22;
  } else {
    t22 = $[46];
  }
  let t23;
  if ($[47] !== t10 || $[48] !== t11 || $[49] !== t22) {
    t23 = <div className="space-y-2">{t10}{t11}{t22}</div>;
    $[47] = t10;
    $[48] = t11;
    $[49] = t22;
    $[50] = t23;
  } else {
    t23 = $[50];
  }
  return t23;
}
function _temp(val) {
  if (val === undefined || val === "") {
    return;
  }
  if (typeof val === "number") {
    return val;
  }
  const parsed = parseFloat(val);
  return isNaN(parsed) ? undefined : parsed;
}